// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'flag';

export const Component = () => (
  <path d='M20.188.002H4.957a.946.946 0 0 0-.67.287A.946.946 0 0 0 4 .96v23.085c0 .335.144.479.479.479.335 0 .479-.144.479-.48v-12.26h15.23c.43 0 .766-.144 1.053-.431.288-.288.432-.623.432-1.054V1.485c0-.431-.144-.766-.432-1.054A1.408 1.408 0 0 0 20.188 0v.002Zm.478 1.484v8.812c0 .336-.143.48-.479.48H4.957V.958h15.23c.336 0 .48.192.48.527Z' />
);

export const viewBox = '0 0 25 25';
